export default __webpack_public_path__ + "static/media/starrySkyImg.4b006e35.webp";